import { onFirebaseWeddingEvents } from '@bridebook/web/lib/events/actions';

export enum WeddingEventsActionTypes {
  ON_FIREBASE_WEDDING_EVENTS = '[Wedding Events] On wedding events Firebase',
}

export type IOnFirebaseWeddingEventsAction = ReturnType<typeof onFirebaseWeddingEvents>;
